/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import baseGlobal from '@amblique/base/app/theme/foundations/styles';

export default {
  global: {
    ...baseGlobal.global,

    '*': {
      scrollbarColor: '#8C683B #F7F5F0',
      scrollbarWidth: 'thin',
    },

    '.sr-only': {
      border: '0',
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px 0',
      overflow: 'hidden',
      padding: '0',
      position: 'absolute',
    },
  },
};
